import { render } from "./InfoLayout2.vue?vue&type=template&id=0ac81a0e&scoped=true"
import script from "./InfoLayout2.vue?vue&type=script&lang=js"
export * from "./InfoLayout2.vue?vue&type=script&lang=js"

import "./InfoLayout2.vue?vue&type=style&index=0&id=0ac81a0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac81a0e"]])

export default __exports__